import { globalStyle, style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const editorContainer = style({
  backgroundColor: vars.color.mainHover,
  borderRadius: vars.buttons.radius,
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  lineHeight: 1.4,
  color: vars.color.dark,
  padding: 10
})

export const editorBody = style({
  marginBottom: 10,
  minHeight: 90,
  outline: 'none'
})

export const editorReduced = style({
  maxHeight: 100,
  overflowY: 'auto'
})

export const editorEmpty = style({
  selectors: {
    '&:first-child:before': {
      content: 'attr(data-placeholder)',
      color: vars.color.medium,
      float: 'left',
      height: 0,
      pointerEvents: 'none'
    }
  }
})

export const editorBubbleMenu = style({
  display: 'flex',
  gap: 8,
  backgroundColor: vars.color.white,
  height: 32,
  alignItems: 'center',
  border: `2px solid ${vars.color.mediumLighter}`,
  borderRadius: vars.buttons.radius,
  zIndex: 100
})

export const editorBubbleMenuSeparator = style({
  width: 1,
  height: 16,
  backgroundColor: vars.color.mediumLighter,
  flexShrink: 0
})

export const editorCellColorWrapper = style({
  position: 'relative'
})

export const editorCellColorPalette = style({
  position: 'absolute',
  bottom: 'calc(100% + 6px)',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: vars.color.white,
  border: `2px solid ${vars.color.mediumLighter}`,
  borderRadius: vars.buttons.radius,
  boxShadow: vars.shadow,
  padding: 8,
  zIndex: 20,
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 20px)',
  gap: 4
})

export const editorCellColorSwatch = style({
  width: 20,
  height: 20,
  borderRadius: 4,
  border: `1px solid ${vars.color.inactive}`,
  cursor: 'pointer',
  transition: 'transform 0.1s',
  ':hover': {
    transform: 'scale(1.2)'
  }
})

export const editorButtonToggle = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '0 5px',
  color: vars.color.mediumDarker,
  transition: 'color 0.2s',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',

  ':hover': {
    color: vars.color.dark
  }
})

export const editorButtonToggleActive = style({
  color: vars.color.dark
})

export const editorTableMenuDanger = style({
  ':hover': {
    color: vars.color.danger
  }
})

export const editorBottom = style({
  display: 'flex',
  gap: 8,
  flexWrap: 'wrap',
  rowGap: 12,
  alignItems: 'flex-end'
})

export const editorMenuBottom = style({
  display: 'flex',
  flex: 1,
  gap: 10,
  marginLeft: -5
})

export const editorOptions = style({
  position: 'relative',
  display: 'flex',
  marginLeft: 'auto',
  gap: 8
})

export const editorOptionsTrigger = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontSize: vars.font.smallNormal.size,
  fontWeight: vars.font.smallNormal.weight,
  color: vars.color.mediumDarker,
  transition: 'color 0.2s'
})

export const editorOptionsContent = style({
  position: 'absolute',
  height: 0,
  overflow: 'hidden',
  transition: 'all 0.2s',
  opacity: 0,
  bottom: 0,
  right: 0,
  backgroundColor: vars.color.white,
  border: `2px solid ${vars.color.mediumLighter}`,
  borderRadius: vars.buttons.radius,
  boxShadow: vars.shadow,
  padding: '0 10px',
  zIndex: 1
})

export const editorOptionsContentActive = style({
  height: 'auto',
  overflow: 'visible',
  padding: 10,
  opacity: 1,
  bottom: 'calc(100% + 8px)'
})

export const editorDisplay = style({
  display: 'block'
})

export const editorDisabled = style({
  opacity: 0.5,
  pointerEvents: 'none',
  cursor: 'not-allowed'
})

export const editorSplitButton = style({
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
})

export const editorSplitButtonChevron = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: vars.color.mediumDarker,
  transition: 'color 0.2s',
  fontSize: 9,
  display: 'flex',
  alignItems: 'center',
  padding: 0,

  ':hover': {
    color: vars.color.dark
  }
})

export const editorDropdownPanel = style({
  position: 'absolute',
  bottom: 'calc(100% + 6px)',
  left: 0,
  backgroundColor: vars.color.white,
  border: `2px solid ${vars.color.mediumLighter}`,
  borderRadius: vars.buttons.radius,
  boxShadow: vars.shadow,
  padding: 4,
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 120,
  gap: 2
})

export const editorDropdownItem = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '5px 10px',
  color: vars.color.dark,
  fontSize: vars.font.smallNormal.size,
  fontWeight: vars.font.smallNormal.weight,
  borderRadius: 6,
  textAlign: 'left',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  whiteSpace: 'nowrap',
  transition: 'background 0.15s',

  ':hover': {
    backgroundColor: vars.color.mainHover
  }
})

export const editorDropdownItemActive = style({
  backgroundColor: vars.color.mainHover,
  color: vars.color.dark,
  fontWeight: '600'
})

export const editorLinkPopover = style({
  position: 'absolute',
  bottom: 'calc(100% + 6px)',
  left: 0,
  backgroundColor: vars.color.white,
  border: `2px solid ${vars.color.mediumLighter}`,
  borderRadius: vars.buttons.radius,
  boxShadow: vars.shadow,
  padding: '8px 10px',
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  minWidth: 350
})

export const editorLinkInput = style({
  flex: 1,
  border: 'none',
  borderRadius: vars.buttons.radius,
  padding: '6px 10px',
  color: vars.color.dark,
  height: 36,
  backgroundColor: vars.color.mainHover,
  outline: 'none',
  '::placeholder': {
    color: vars.color.medium
  }
})

globalStyle(`input[type='text']${editorLinkInput}`, {
  float: 'none',
  width: 'auto',
  margin: 0,
  border: 'none',
  height: 36,
  padding: '6px 10px'
})

export const editorLinkAction = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px 6px',
  color: vars.color.mediumDarker,
  fontSize: 12,
  borderRadius: 6,
  transition: 'color 0.2s',
  display: 'flex',
  alignItems: 'center',

  ':hover': {
    color: vars.color.dark
  }
})

globalStyle(`${editorBody} *`, {
  margin: 0
})

globalStyle(`${editorBody} p:not(:last-child)`, {
  marginBottom: '1em'
})

globalStyle(`${editorBody} a`, {
  color: vars.color.darkLighter,
  textDecoration: 'underline'
})

globalStyle(`${editorDisplay} *`, {
  margin: 0
})

globalStyle(`${editorDisplay} p:not(:last-child)`, {
  marginBottom: '1em'
})

globalStyle(`${editorBody} table`, {
  borderCollapse: 'collapse',
  width: '100%',
  tableLayout: 'fixed'
})

export const editorCompactTables = style({})

globalStyle(`${editorCompactTables} table`, {
  width: 'auto'
})

globalStyle(`${editorBody} td, ${editorBody} th`, {
  border: `1px solid ${vars.color.inactive}`,
  padding: '6px 10px',
  verticalAlign: 'top',
  position: 'relative'
})

globalStyle(`${editorBody} .selectedCell`, {
  backgroundColor: vars.color.mainHover
})

globalStyle(`${editorBody} .column-resize-handle`, {
  position: 'absolute',
  right: -2,
  top: 0,
  bottom: 0,
  width: 4,
  backgroundColor: vars.color.darkLighter,
  opacity: 0.5,
  pointerEvents: 'none'
})

globalStyle('.resize-cursor', {
  cursor: 'col-resize'
})

globalStyle(`${editorBody} [data-resize-container]`, {
  width: 'fit-content'
})

globalStyle(`${editorBody} [data-resize-handle]`, {
  position: 'absolute',
  width: 10,
  height: 10,
  backgroundColor: vars.color.white,
  border: `2px solid ${vars.color.darkLighter}`,
  borderRadius: '50%',
  zIndex: 10,
  opacity: 0,
  transition: 'opacity 0.15s'
})

globalStyle(
  `${editorBody} div:hover > [data-resize-handle], ${editorBody} div:focus-within > [data-resize-handle], ${editorBody} .ProseMirror-selectednode [data-resize-handle]`,
  {
    opacity: 1
  }
)

globalStyle(
  `${editorBody} [data-resize-handle="top-left"], ${editorBody} [data-resize-handle="bottom-right"]`,
  {
    cursor: 'nwse-resize'
  }
)

globalStyle(
  `${editorBody} [data-resize-handle="top-right"], ${editorBody} [data-resize-handle="bottom-left"]`,
  {
    cursor: 'nesw-resize'
  }
)

globalStyle(`${editorBody} ul[data-type="taskList"]`, {
  listStyle: 'none',
  padding: 0
})

globalStyle(`${editorBody} ul[data-type="taskList"] li`, {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 6
})

globalStyle(`${editorBody} ul[data-type="taskList"] li label`, {
  marginTop: 2
})
